export default __webpack_public_path__ + "static/media/butcher1.aef827df.png";